<template>
  <div class="card card-gestor">
    <div class="card-header">
      <h4 class="title">{{title}}</h4>
    </div>
    <div class="card-content">
      <ul class="list-unstyled team-members">
        <li v-if="(currentUser.manager.hasOwnProperty('name'))">
          <div class="row">
            <div class="col-xs-3">
              <div class="avatar">
                <img :src="currentUser.manager.avatar_url" :alt="currentUser.manager.name" class="img-circle img-no-padding img-responsive img-gestor">
              </div>
            </div>
            <div class="col-xs-9 n-gestor">
              {{ currentUser.manager.name }}
              <br>
              <span class="text-success">
                <small>{{ currentUser.manager.position }}</small>
              </span>
              <br/>
               <button v-if="evaluationMe" type="button" class="btn btn-wd btn-success" @click="toEvaluateMe()">
                 <span class="btn-label"><i class="fa fa-thumbs-up"></i></span>Me avalia aí
              </button>
            </div>
          </div>
        </li>
        <li class="text-center" v-else> <strong>Entre em contato com o seu gestor.</strong> </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        title: 'Gestor Imediato',
        evaluationMe: false
      }
    },
    methods: {
      toEvaluateMe () {
        swal({
          title: 'Você tem certeza?',
          text: `Seu gestor imediato receberá um e-mail para agendar sua avaliação.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, quero enviar!',
          buttonsStyling: false,
          preConfirm: () => {
            let url = '/collaborator/to-evaluation-me'
            return axios.post(url)
            .catch(error => {
              let message = 'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }
              swal.showValidationError(message)
              return (new Promise((resolve, reject) => {
                reject(new Error(message))
              }))
            })
          }
        }).then(function () {
          swal({
            title: 'Enviado!',
            text: 'Seu gestor imediato recebeu um e-mail requisitando que ele realize sua avaliação.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
        })
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }

</script>
<style>
.btn{padding: 3px 18px !important;}

.card .img-gestor {
    max-width: 78%;
    height: auto;
}

@media screen and (max-width: 480px) {
  .card .img-gestor {
      max-width: 124%;
      height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/MembersCard.vue